(function () {
	'use strict';

	angular.module('qbePortal').controller('qbRadioLabel', qbRadioLabelController);

	qbRadioLabelController.$inject = ['$scope', 'labelService'];

	function qbRadioLabelController($scope, labelService) {
		var vm = this,
			fieldKey = $scope.fieldKey;

		vm.fieldName = $scope.name;
		vm.isError = false;

		$scope.$on('enable-field-error-class', function (event) {
			vm.isError = true;
		});

		$scope.$on('element-id-set', function (event, labelKey, id) {
			if (fieldKey !== labelKey) return;
			vm.labelFor = id;
		});

		vm.label = $scope.label || labelService.getLabelFor(fieldKey);

		vm.addTooltip = $scope.hasOwnProperty('addTooltip');
		if (vm.addTooltip)
			vm.tooltip = labelService.getTooltipFor(fieldKey);
	}

	angular.module('qbePortal').directive('qbRadioLabel', function () {
		return {
			templateUrl: '../ngviews/directives/qbRadioLabel.html',
			restrict: 'E',
			controller: qbRadioLabelController,
			controllerAs: 'vm',
			// transclude: true,
			scope: {
				label: '@',
				fieldKey: '@',
				addTooltip: '@?',
			},
		}
	});
})();
